import React from 'react';
import NavBar from ".././pageChild/NavBar";
import Intagram from ".././pageChild/Intagram";
import Footer from ".././pageChild/Footer";
import End from ".././pageChild/End";
import Products from ".././pageChild/Products";
import callApi from './../../utils/apicaler';
import Filter from './../pageXemthem/Filter';
import axios from 'axios';
import {
  Link
} from "react-router-dom";
 
class Sale extends React.Component{
  constructor(props){
            super(props);

            this.state = {
                redirct:0,
                products:[],
                loader:"",
                carts:[],
                cartId:0,
                start:0,
                end:9,
                status:0,
                days:"",
                hours:"",
                mins:"",
                secs:"",
                set:false
            }
        }

        componentDidMount(){
            {this.apiExpress()}
          var cart = JSON.parse(sessionStorage.getItem('products'));
          this.setState({carts:cart})
            if(cart === null){
                console.log("!")
            }else{
                cart.map((carts, index)=>{
                    this.setState({cartId: index + 1})
                })
            }
        }

        apiExpress = () =>{
            callApi('5f1b03fe6c6c7f0072c612af', 'GET', null).then(res =>{
                let {start, end} = this.state;
                this.setState({
                    redirct : res.status,
                    products : res.data
                })
            })
        }
        addSplice = () =>{
            let {end} = this.state;
            this.setState({set: true})
            setTimeout(()=>{ 
                this.setState({set:false,end: end+3})
            }, 1000);
        }
        showTable = (datas, status) =>{
            var result = null;
                result = datas.map((product, index)=>{
                    return ( product.sale === "SALE" || product.sale === "HET HANG" ?
                        <div className="col-xs-6 col-sm-4 col-md-4 col-lg-3" style={{paddingRight:"6px", paddingLeft: "6px"}} key={index}>
                            <Link to={`product/${product._id}`}>
                                <div className="colection1" >
                                {product.sale === "HET HANG" ? <p style={{background:"red"}}>Hết hàng</p> : product.sale === "SALE" ? <p style={{background:"red"}}>{`Sale ${product.salePrice}`}</p> : <p>New</p>}
                                
                                <img src={product.imgeFile} />

                                </div>
                                <div className="title_product">
                                <b>{product.products.slice(0,28)}...</b>
                                <hr/>
                                {product.sale === "SALE" ? 
                                <span>
                                <span style={{textDecoration: product.sale === "SALE" ? "line-through" : ""}}>{product.price}.000 Vnd</span>
                                <br/>
                                <b style={{fontSize:"17px", color:"red"}}>{((parseInt(product.price)*(1 - parseInt(product.salePrice)/100.0)))}.000VND</b>
                                </span>
                                :
                                <span>{product.price}.000VND</span>
                                }
                            </div>
                            </Link>
                        </div> 
                        : 
                        ""
                    )
                })
            return result
        }
  render(){
    const {products,set, redirct, loader,cartId, start, end, status, days, hours, mins, secs} = this.state;
        var expiry = new Date("August 6,2020 24:00:00");
        setInterval(()=> {
            var ongo=new Date().getTime();
            var timeleft=expiry-ongo;
            var days=Math.floor(timeleft/(1000*60*60*24));
            var hours=Math.floor(timeleft%(1000*60*60*24)/(1000*60*60));
            var mins=Math.floor(timeleft%(1000*60*60)/(60*1000));
            var secs=Math.floor(timeleft%(60*1000)/(1000));
            if(timeleft>0) {
                this.setState({days:days,hours:hours,mins:mins,secs:secs})
            }
            else {
            console.log('time over');
            }
        },1000);

    var wapper = <div style={{background:"rgb(231, 239, 247)"}} className={`container-fluid custom_fluid ${loader}`}>
                    <div className="row custom_row">
                      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 custom_col">
                        <NavBar cartId={cartId} />
                      </div>
                    </div>
                   <div className="row custom_row">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 custom_col">
                            <div className="cart_img thoitrang"></div>
                        </div>
                    </div>
                    <div className="row custom_row">
                        <div className="title_pay">
                            <h3>HÀNG SALSE</h3>
                            <div className="deb" style={{textAlign:"center"}}>
                                <span className="t1"> <b>●</b> &nbsp;TIME out</span><br/>
                                <span style={{fontSize:"20px", color:"red"}} id="main" onload="">{days} &nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{hours}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{mins}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{secs}</span>
                                <br/><span style={{padding:0, textDecoration:"line-through"}} className="t1">&nbsp;&nbsp;&nbsp;Ngày : Giờ : phút : giây</span>
                            <hr/>
                            </div>
                        </div>
                        <div className="box_main">
                            {this.showTable(products, status)}
                        </div>
                    </div>
                    <div className="send_mail">
                        {
                            set === false ? 
                            "" : 
                            <div className="loading" style={{marginTop:"0", padding:"40px"}}>Loading&#8230;</div>
                        }
                        <button type="button" onClick={this.addSplice}>XEM THEM</button>
                    </div>
                    <Intagram />
                    <Footer />
                    <End />
                </div>
      return ( 
            <div>
                { redirct === 200 ? wapper : <div className="loader loader-black loader-1"></div>}
            </div>
     
              
  
        )
      }
  }
export default Sale;